import { UAParser } from "ua-parser-js";

const uaParser = new UAParser();
const device = uaParser.getDevice();

export const isMobile = (): boolean => device.type === "mobile";

export const isAppWebView = (): boolean =>
  window.location.search.search(new RegExp("cheerz-app=true", "g")) > -1;
